import { render, staticRenderFns } from "./Zxzhibo.vue?vue&type=template&id=3b780691&scoped=true"
import script from "./Zxzhibo.vue?vue&type=script&lang=js"
export * from "./Zxzhibo.vue?vue&type=script&lang=js"
import style0 from "./Zxzhibo.vue?vue&type=style&index=0&id=3b780691&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b780691",
  null
  
)

export default component.exports